/** Разбор адреса «Всех референсов» (серверные фильтры и порядок) — чистая логика, без React. */
import type { AllItemsParams, Verdict } from "../../../lib/library";

export type Sort = "new" | "old" | "library";
export type VerdictParam = Verdict | "none";

export const SORTS: Sort[] = ["new", "old", "library"];
export const VERDICTS: VerdictParam[] = ["works", "fails", "none"];

export function positiveInt(raw: string | null): number | null {
  const n = Number(raw);
  return raw && Number.isInteger(n) && n > 0 ? n : null;
}

type Params = { get(name: string): string | null };

export type AllRefsFilter = {
  category: string;
  libraryId: number | null;
  tag: number | "none" | null;
  verdict: VerdictParam | null;
  q: string;
};

export function parseAllRefs(search: Params): AllRefsFilter & { sort: Sort } {
  const category = search.get("category") ?? "";
  const libraryId = positiveInt(search.get("library"));
  const tag: number | "none" | null = search.get("tag") === "none" ? "none" : positiveInt(search.get("tag"));
  const verdict = VERDICTS.find((v) => v === search.get("verdict")) ?? null;
  const q = search.get("q") ?? "";
  const sort = SORTS.find((s) => s === search.get("sort")) ?? "new";
  return { category, libraryId, tag, verdict, q, sort };
}

/** Тело запроса: пустые фильтры не передаются. */
export function allRefsQuery(f: AllRefsFilter): AllItemsParams {
  return {
    ...(f.category ? { category: f.category } : {}),
    ...(f.libraryId !== null ? { library_id: f.libraryId } : {}),
    ...(f.tag !== null ? { tag: f.tag } : {}),
    ...(f.verdict ? { verdict: f.verdict } : {}),
    ...(f.q ? { q: f.q } : {}),
  };
}
